import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshIcon from 'assets/svgs/refreshIcon.svg';
import moment from 'moment';
import './RefreshButton.scss';

let timeLeft = 15;

const RefreshButton = ({
  lastFetchTime,
  autoRefresh,
  setIsAutoRefreshStarted,
  isAutoRefreshStartedRef,
  fetchData,
}) => {
  const { t } = useTranslation();
  const [refreshTime, setRefreshTime] = useState(lastFetchTime);
  const [countdownTime, setCountdownTime] = useState(timeLeft);

  const resetCountDown = () => {
    timeLeft = 15;
    setCountdownTime(timeLeft);
  };

  const refreshData = useCallback(async () => {
    await fetchData();
    resetCountDown();
    // setRefreshTime(moment().format('hh:mm A'));
  }, [fetchData]);

  const renderRefreshLabel = () => {
    if (sessionStorage.getItem('isUpdateStatus') && autoRefresh) {
      return '';
    }
    if (autoRefresh) {
      return (
        <>
          {t('common.labels.autoRefresh')}
          <span className="contdown-number">
            {countdownTime > 0 && t('common.labels.autoRefreshValue', { time: countdownTime })}{' '}
          </span>
        </>
      );
    }
    return `${t('common.labels.lastRefresh')} ${refreshTime}`;
  };

  const restartTimer = useCallback(async () => {
    if (isAutoRefreshStartedRef) isAutoRefreshStartedRef.current = true;
    setIsAutoRefreshStarted(true);
    resetCountDown();
    await fetchData();
    setIsAutoRefreshStarted(false);
    if (isAutoRefreshStartedRef) isAutoRefreshStartedRef.current = false;
  }, [fetchData, setIsAutoRefreshStarted, isAutoRefreshStartedRef]);

  useEffect(() => {
    setRefreshTime(lastFetchTime || moment().format('hh:mm A'));
  }, [lastFetchTime]);

  useEffect(() => {
    if (autoRefresh) {
      const customTimer = setInterval(() => {
        if (!sessionStorage.getItem('isUpdateStatus')) {
          if (timeLeft > 1) {
            timeLeft--;
            setCountdownTime(timeLeft);
          } else {
            // Timer about to reach 0, trigger refresh
            restartTimer();
          }
        } else {
          resetCountDown();
        }
      }, 1000);
      return () => {
        clearInterval(customTimer);
      };
    }
  }, [autoRefresh, restartTimer]);

  return (
    <div className="refresh-section">
      <div className="d-inline-block">{renderRefreshLabel()}</div>
      <button className="btn-link" onClick={refreshData}>
        {t('common.labels.refresh')} <RefreshIcon />
      </button>
    </div>
  );
};

export default RefreshButton;
